import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    // supportedLngs: [
    //   'en',
    //   'zh-Hans-HK',
    //   'es-MX',
    //   'bs',
    //   'de',
    //   'es',
    //   'fr',
    //   'hr',
    //   'it',
    //   'nl',
    //   'sr',
    //   'sv',
    // ],
    fallbackLng: {
      'de-CH': ['fr', 'it'], //French and Italian are also spoken in Switzerland
      'zh-HK': ['zh-Hans', 'zh-Hans-HK', 'en'],
      default: ['en'],
    },
    detection: {
      order: ['path', 'cookie', 'htmlTag', 'localStorage', 'subdomain'],
      // order: ['cookie','htmlTag', 'localStorage', 'path', 'subdomain'],
      caches: ['cookie'],
    },
    lng: 'en',
    backend: {
      loadPath: `https://${process.env.REACT_APP_STORAGERESOURCENAME}.blob.core.windows.net/locales/static/{{lng}}.json`,
      // loadPath: '/translations/{{lng}}/translation.json',
    },
    // react: { useSuspense: false },
  })

export default i18n
